import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, MESSAGES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'messageStats',
  pluralName: 'messagesStats',
  url: `${MESSAGES_URL}/stats`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
